module.exports = __webpack_public_path__ + "static/062-6f6d2a940d7a4ff605be29d1704919ab.jpg";